var _g, _path, _path2, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "10 7 100 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_8300_25021)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 90,
    height: 90,
    rx: 8,
    fill: "#133F7A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 6.5,
    width: 89,
    height: 89,
    rx: 7.5,
    stroke: "#EBFAFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3312 84.5H89.75L58.0295 17H47.2292V17.5182C50.4661 19.5493 50.6982 22.3596 48.7473 27.0876L22.25 84.5H29.5695L38.4151 64.2795H70.3598L79.3312 84.5ZM40.6596 58.8673L54.1437 28.1078L67.8349 58.8673H40.6596Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102 10C102 12.2057 103.794 14 106 14C108.229 14 110 12.2057 110 10C110 7.79429 108.229 6 106 6C103.794 6 102 7.79429 102 10ZM102.914 10C102.914 8.24 104.297 6.8 106 6.8C107.714 6.8 109.074 8.22857 109.074 10C109.074 11.7714 107.714 13.2 106 13.2C104.297 13.2 102.914 11.76 102.914 10ZM104.537 11.9657H105.451V10.4114H105.714C106.549 10.4114 106.583 10.7429 106.594 11.0514C106.617 11.6686 106.583 11.7714 106.743 11.9657H107.68C107.52 11.7486 107.554 11.6343 107.52 11.0171C107.497 10.64 107.463 10.1714 106.949 10.0686V10.0457C107.566 9.85143 107.623 9.38286 107.623 9.13143C107.623 8.88 107.623 7.96571 106.286 7.96571H104.537V11.9657ZM105.451 8.67429H106.057C106.194 8.67429 106.697 8.68571 106.697 9.18857C106.697 9.42857 106.583 9.70286 106.137 9.70286H105.451V8.67429Z",
    fill: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8300_25021)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8300_25021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 104,
    width: 8,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5615 104.9V105.764H86.1298V109.544H90.9616V110.386H86.1298V114.753H91.9002V115.7H84.7002V104.9H91.5615Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8300_25021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4502 102.65H94.1502V117.95H82.4502V102.65Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8300_25021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 104,
    width: 11,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7691 104.9L67.4571 114.037L71.0567 104.9H72.1002L67.698 115.7H66.6545L62.2002 104.9H63.7691Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8300_25021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9502 102.65H74.3502V117.95H59.9502V102.65Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8300_25021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 104,
    width: 10,
    height: 13
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6477 104.688C47.502 104.688 48.7304 104.928 49.4362 105.19V106.304L49.4069 106.328C48.6931 105.697 47.4696 105.467 46.4344 105.467C43.9929 105.467 42.0489 107.325 42.0489 110.247C42.0489 113.729 44.1683 115.092 46.6422 115.114C47.6438 115.121 48.9571 114.936 49.71 114.14L49.7338 114.165V115.534C48.8153 115.799 47.5442 116.042 46.5755 116.04C43.5065 116.027 40.5352 114.248 40.5352 110.409C40.5352 107.524 42.8147 104.688 46.6477 104.688Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8300_25021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2856 102.438H51.9843V118.29H38.2856V102.438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8300_25021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 104,
    width: 10,
    height: 13
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3039 104.941V111.929C53.3039 113.512 53.8124 115.212 56.2386 115.212C58.5224 115.212 59.5075 113.853 59.5075 111.839V104.941H60.5043V111.808C60.5043 114.166 58.9556 116.038 56.2441 116.038C53.5343 116.038 51.8696 114.395 51.8696 112.003V104.941H53.3039Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8300_25021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6196 102.691H62.7543V118.288H49.6196V102.691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8300_25021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 104,
    width: 12,
    height: 12
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.369 104.862L40.2978 115.784H38.6789L37.2849 112.512H32.3213L30.9475 115.784H29.8096L33.9267 106.494C34.2305 105.73 34.1938 105.274 33.6908 104.946V104.862H35.369ZM34.7835 106.65L32.6764 111.67H36.9237L34.7835 106.65Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8300_25021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5596 102.613H42.5478V118.034H27.5596V102.613Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_8300_25021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 104,
    width: 10,
    height: 13
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0732 104.941V111.929C75.0732 113.512 75.5823 115.212 78.0079 115.212C80.2916 115.212 81.2768 113.853 81.2768 111.839V104.941H82.2742V111.808C82.2742 114.166 80.7249 116.038 78.014 116.038C75.3048 116.038 73.6401 114.395 73.6401 112.003V104.941H75.0732Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_8300_25021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3901 102.691H84.5241V118.288H71.3901V102.691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_8300_25021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 104,
    width: 11,
    height: 12
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0032 104.89L15.324 113.724H15.3833L18.7635 104.89H20.7515V115.672H19.4112V109.042C19.4112 108.305 19.4461 107.368 19.5145 106.232H19.4552L15.8618 115.672H14.7502L11.2001 106.218H11.1415C11.2154 107.004 11.2515 107.975 11.2515 109.131V115.672H10.0005V104.89H12.0032Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_8300_25021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75098 102.64H23.0019V117.922H7.75098V102.64Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_8300_25021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 107,
    width: 8,
    height: 13
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6533 107.574L25.3993 112.183C25.7672 113.187 25.9927 113.921 26.0764 114.389H26.1357C26.1797 114.207 26.2799 113.866 26.4376 113.367C26.5947 112.868 26.7267 112.469 26.8348 112.169L28.4775 107.574H29.9058L26.4223 116.793C26.0838 117.688 25.6816 118.329 25.2147 118.718C24.7484 119.106 24.1715 119.3 23.484 119.3C23.1155 119.3 22.75 119.259 22.387 119.175V118.12C22.6321 118.179 22.9273 118.209 23.2707 118.209C23.693 118.209 24.0518 118.092 24.3457 117.859C24.6403 117.625 24.8811 117.265 25.0674 116.778L25.4873 115.701L22.2324 107.574H23.6533Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_8300_25021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9824 105.324H32.1557V121.55H19.9824V105.324Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_8300_25021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 104,
    width: 7,
    height: 7
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5386 104.186C97.4829 104.186 98.285 104.517 98.9467 105.18C99.6065 105.842 99.9368 106.64 99.9368 107.576C99.9368 108.512 99.6065 109.306 98.9467 109.958C98.285 110.608 97.4829 110.936 96.5386 110.936C95.5931 110.936 94.7921 110.608 94.1303 109.958C93.4675 109.306 93.1382 108.512 93.1382 107.576C93.1382 106.64 93.4675 105.842 94.1303 105.18C94.7921 104.517 95.5931 104.186 96.5386 104.186ZM96.5386 104.708C95.7438 104.708 95.0674 104.99 94.5096 105.553C93.9527 106.115 93.6743 106.79 93.6743 107.576C93.6743 108.362 93.9558 109.036 94.5168 109.598C95.0799 110.161 95.7531 110.444 96.5386 110.444C97.3229 110.444 97.9972 110.161 98.5582 109.598C99.1213 109.036 99.3997 108.362 99.3997 107.576C99.3997 106.79 99.1223 106.115 98.5665 105.553C98.0086 104.99 97.3333 104.708 96.5386 104.708ZM96.5521 105.65C96.95 105.65 97.2855 105.74 97.5598 105.926C97.832 106.11 97.9692 106.391 97.9692 106.769C97.9692 107.327 97.6762 107.67 97.0902 107.8L98.1187 109.471H97.2834L96.3889 107.874H95.8975V109.471H95.2118V105.65H96.5521ZM96.5229 106.231H95.8975V107.322H96.4482C97.005 107.322 97.2834 107.132 97.2834 106.755C97.2834 106.405 97.03 106.231 96.5229 106.231Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_8300_25021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8887 101.936H102.187V113.186H90.8887V101.936Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8300_25021",
    x: 0,
    y: 0,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.243137 0 0 0 0 0.494118 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8300_25021"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8300_25021",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8300_25021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 15.3,
    fill: "white",
    transform: "translate(10 104)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSecondary);
export default __webpack_public_path__ + "static/media/logo-secondary.d80b79010cd42a51dd06cd58a1b94e01.svg";
export { ForwardRef as ReactComponent };